import React, { useEffect, useState } from 'react';

import { CmmContainer, CmmSubTitle, SalesTable, SalesTableBody, SalesTableCell, SalesTableRow } from 'components/Dashboard';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Grid from '@mui/material/Grid';
import { DataGrid, GridToolbarContainer, GridToolbarExport } from '@mui/x-data-grid';
import axios from 'axios';

const columns = [
  { field: 'companyName', headerName: '업체명', width: 281, headerAlign: 'center', align: 'left' },
  { field: 'createdAt', headerName: '가입일', width: 125, headerAlign: 'center', align: 'center' },
  {
    field: 'couponCnt',
    headerName: '사용권개수',
    width: 120,
    headerAlign: 'center',
    align: 'right',
    valueGetter: (params) => Number(params?.value)?.toLocaleString('en-US')
  },
  {
    field: 'couponAmt',
    headerName: '금액(VAT포함)',
    width: 220,
    headerAlign: 'center',
    align: 'right',
    valueGetter: (params) => Number(params?.value)?.toLocaleString('en-US')
  }
];

const simpleColumns = [
  { field: 'scale', headerName: '업체 규모', width: 200, headerAlign: 'center', align: 'center' },
  {
    field: 'count',
    headerName: '업체 수',
    width: 114,
    headerAlign: 'center',
    align: 'right',
    valueGetter: (params) => Number(params?.value)?.toLocaleString('en-US')
  },
  {
    field: 'CouponOrders.couponCount',
    headerName: '주문 수',
    width: 114,
    headerAlign: 'center',
    align: 'right',
    valueGetter: (params) => Number(params?.value)?.toLocaleString('en-US')
  },
  {
    field: 'CouponOrders.sumCouponCnt',
    headerName: '사용권개수',
    width: 114,
    headerAlign: 'center',
    align: 'right',
    valueGetter: (params) => Number(params?.value)?.toLocaleString('en-US')
  },
  {
    field: 'CouponOrders.sumCouponAmt',
    headerName: '금액(VAT포함)',
    width: 216,
    headerAlign: 'center',
    align: 'right',
    valueGetter: (params) => Number(params?.value * 1.1)?.toLocaleString('en-US')
  }
];

export default function CompanySales(props) {
  const { year } = props.srchData;

  const [aRows, setARows] = useState([]);
  const [bRows, setBRows] = useState([]);
  const [cRows, setCRows] = useState([]);
  const [simpleRows, setSimpleRows] = useState([]);

  const getCompanySales = async (scale) => {
    return axios
      .get('/api/dashboard/company-sales', { params: { scale, year } })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        alert(error.data.message);
      });
  };

  const getSimpleCompanySales = async (scale) => {
    return axios
      .get('/api/dashboard/company-sales/simple', { params: { year } })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        alert(error.data.message);
      });
  };

  useEffect(async () => {
    if (year) {
      await getCompanySales('A').then((result) => {
        setARows(result);
      });
      await getCompanySales('B').then((result) => {
        setBRows(result);
      });
      await getCompanySales('C').then((result) => {
        setCRows(result);
      });
      await getSimpleCompanySales().then((result) => {
        setSimpleRows([...result]);
      });
    }
  }, [year]);

  return (
    <Box sx={{ display: 'block' }}>
      <Stack spacing={2} sx={{ mt: 3, maxWidth: 800 }}>
        <Box sx={{ flexGrow: 1 }}>
          <Stack>
            <Grid item xs={2} sm={5} md={5}>
              <CmmContainer>
                <CmmSubTitle
                  title={`기업 통계 (${simpleRows.reduce((count, row, idx) => {
                    return count + Number(row.count);
                  }, 0)})`}
                />
                <DataGrid rowHeight={40} rows={simpleRows} columns={simpleColumns} hideFooter />
                <SalesTable>
                  <SalesTableBody>
                    <SalesTableRow>
                      <SalesTableCell th sx={{ textAlign: 'center', width: 200 }}>
                        소계
                      </SalesTableCell>
                      <SalesTableCell th unit="" sx={{ textAlign: 'right', width: 114 }}>
                        {simpleRows
                          .reduce((count, row, idx) => {
                            return count + Number(row.count);
                          }, 0)
                          .toLocaleString('en-US')}
                      </SalesTableCell>
                      <SalesTableCell th unit="건" sx={{ textAlign: 'right', width: 114 }}>
                        {simpleRows
                          .reduce((count, row, idx) => {
                            return count + Number(row[`CouponOrders.couponCount`]);
                          }, 0)
                          .toLocaleString('en-US')}
                      </SalesTableCell>
                      <SalesTableCell th unit="개" sx={{ textAlign: 'right', width: 114 }}>
                        {simpleRows
                          .reduce((count, row, idx) => {
                            return count + Number(row[`CouponOrders.sumCouponCnt`]);
                          }, 0)
                          .toLocaleString('en-US')}
                      </SalesTableCell>
                      <SalesTableCell th unit="원" sx={{ textAlign: 'right', width: 213 }}>
                        {(
                          simpleRows.reduce((count, row, idx) => {
                            return count + Number(row[`CouponOrders.sumCouponAmt`]);
                          }, 0) * 1.1
                        ).toLocaleString('en-US')}
                      </SalesTableCell>
                    </SalesTableRow>
                  </SalesTableBody>
                </SalesTable>
              </CmmContainer>
            </Grid>
            <Grid item xs={2} sm={5} md={4} sx={{ mt: 2 }}>
              <CmmContainer>
                <CmmSubTitle title={`중견기업 (${cRows.length})`} />
                <DataGrid rowHeight={40} rows={cRows} columns={columns} hideFooter />
                <SalesTable>
                  <SalesTableBody>
                    <SalesTableRow>
                      <SalesTableCell th sx={{ textAlign: 'center', width: 281 }}>
                        소계
                      </SalesTableCell>
                      <SalesTableCell th unit="개" sx={{ textAlign: 'right', width: 245 }}>
                        {cRows
                          .reduce((count, row, idx) => {
                            return count + Number(row.couponCnt);
                          }, 0)
                          .toLocaleString('en-US')}
                      </SalesTableCell>
                      <SalesTableCell th unit="원" sx={{ textAlign: 'right', width: 220 }}>
                        {cRows
                          .reduce((count, row, idx) => {
                            return count + Number(row.couponAmt);
                          }, 0)
                          .toLocaleString('en-US')}
                      </SalesTableCell>
                    </SalesTableRow>
                  </SalesTableBody>
                </SalesTable>
              </CmmContainer>
            </Grid>
            <Grid item xs={2} sm={5} md={4} sx={{ mt: 2 }}>
              <CmmContainer>
                <CmmSubTitle title={`중소기업 (${bRows.length})`} />
                <DataGrid rowHeight={40} rows={bRows} columns={columns} hideFooter />
                <SalesTable>
                  <SalesTableBody>
                    <SalesTableRow>
                      <SalesTableCell th sx={{ textAlign: 'center', width: 281 }}>
                        소계
                      </SalesTableCell>
                      <SalesTableCell th unit="개" sx={{ textAlign: 'right', width: 245 }}>
                        {bRows
                          .reduce((count, row, idx) => {
                            return count + Number(row.couponCnt);
                          }, 0)
                          .toLocaleString('en-US')}
                      </SalesTableCell>
                      <SalesTableCell th unit="원" sx={{ textAlign: 'right', width: 220 }}>
                        {bRows
                          .reduce((count, row, idx) => {
                            return count + Number(row.couponAmt);
                          }, 0)
                          .toLocaleString('en-US')}
                      </SalesTableCell>
                    </SalesTableRow>
                  </SalesTableBody>
                </SalesTable>
              </CmmContainer>
            </Grid>
            <Grid item xs={2} sm={5} md={4} sx={{ mt: 2 }}>
              <CmmContainer>
                <CmmSubTitle title={`소기업 (${aRows.length})`} />
                <DataGrid rowHeight={40} rows={aRows} columns={columns} hideFooter />
                <SalesTable>
                  <SalesTableBody>
                    <SalesTableRow>
                      <SalesTableCell th sx={{ textAlign: 'center', width: 281 }}>
                        소계
                      </SalesTableCell>
                      <SalesTableCell th unit="개" sx={{ textAlign: 'right', width: 245 }}>
                        {aRows
                          .reduce((count, row, idx) => {
                            return count + Number(row.couponCnt);
                          }, 0)
                          .toLocaleString('en-US')}
                      </SalesTableCell>
                      <SalesTableCell th unit="원" sx={{ textAlign: 'right', width: 220 }}>
                        {aRows
                          .reduce((count, row, idx) => {
                            return count + Number(row.couponAmt);
                          }, 0)
                          .toLocaleString('en-US')}
                      </SalesTableCell>
                    </SalesTableRow>
                  </SalesTableBody>
                </SalesTable>
              </CmmContainer>
            </Grid>
          </Stack>
        </Box>
      </Stack>
    </Box>
  );
}

function CustomToolbar(props) {
  return (
    <GridToolbarContainer>
      <GridToolbarExport printOptions={{ disableToolbarButton: true }} csvOptions={{ utf8WithBom: true, ...props }} />
    </GridToolbarContainer>
  );
}
